<template>
  <div class="withdrawal">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav></user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="提现">
          <div class="content noSelect">
            <div class="form-box">
              <div class="form-item">
                <span class="form-item-key">可提现金额：</span>
                <span class="form-item-price">￥0.00</span>
              </div>
              <el-form ref="form" :rules="rules" :model="form" label-width="100px">
                <el-form-item label="提现方式：" prop="account">
                  <div>
                    <el-radio v-model="form.type" :label="0" border size="mini">支付宝</el-radio>
                    <el-radio v-model="form.type" :label="1" border size="mini">银行卡</el-radio>
                  </div>
                </el-form-item>
                <el-form-item label="到账账号：" prop="account">
                  <el-input v-model="form.account" :placeholder="`请输入${form.type === 0 ? '支付宝' : '银行卡'}账号`" />
                </el-form-item>
                <el-form-item label="真实姓名：" prop="fullname">
                  <el-input v-model="form.fullname" :placeholder="`请输入${form.type === 0 ? '支付宝' : '银行卡'}真实姓名`" />
                </el-form-item>
                <el-form-item label="提现金额：" prop="value">
                  <el-input v-model="form.value" placeholder="请输入提现金额" />
                </el-form-item>
                <el-form-item>
                  <p class="withdrawal-tips">注：关于提现能否成功，请填写真实姓名及账号</p>
                  <div class="submit-btn btn-style">提现</div>
                </el-form-item>
              </el-form>

              <!--              <div class="form-item">-->
              <!--                <span class="form-item-key">提现金额：</span>-->
              <!--                <el-input style="width: 160px;" type="number" placeholder="请输入金额"></el-input> 元-->
              <!--&lt;!&ndash;                <a class="build-zfb" href="javascript:void(0)">绑定支付宝》</a>&ndash;&gt;-->
              <!--              </div>-->
              <!--              <div class="form-item">-->
              <!--                <span class="form-item-key">支付宝姓名：</span>-->
              <!--                <span class="form-item-val">&#45;&#45;</span>-->
              <!--              </div>-->
              <!--              <div class="form-item">-->
              <!--                <span class="form-item-key">支付宝账号：</span>-->
              <!--                <span class="form-item-val">&#45;&#45;</span>-->
              <!--              </div>-->
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import userNav from "@/components/userNav/index";
import footerBox from "@/components/footerBox/index";

export default {
  name: "withdrawal",
  components: { headerNav, userNav, footerBox },
  data() {
    return {
      form: {
        type: 0,
        account: "",
        fullname: "",
        value: 0,
      },
      rules: {
        account: [{ required: true, message: "请输入支付宝账号", trigger: "blur" }],
        fullname: [{ required: true, message: "请输入支付宝真实姓名", trigger: "blur" }],
        value: [{ required: true, message: "请输入提现金额", trigger: "blur" }],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.withdrawal {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  // background-color: #eeeeee;

  .user-center {
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main {
      min-height: calc(100vh - 270px);

      .content {
        padding: 20px;

        .form-box {
          .form-item {
            margin-bottom: 10px;
            .build-zfb {
              color: #127af7;
            }

            .form-item-key {
              font-size: 14px;
              color: #000000;
            }
            .form-item-price {
              font-weight: bolder;
              color: #ff0000;
              font-size: 18px;
            }
          }
          .withdrawal-tips {
            margin: 0;
            color: #ff4b2b;
            font-size: 12px;
            font-weight: bold;
          }
          .submit-btn {
            padding: 10px 30px;
            margin-top: 20px;
          }
        }

        .recharge-title {
          font-size: 16px;
          font-weight: bold;
          color: #0f375a;
          margin-bottom: 20px;
        }

        .pages-box {
          margin-top: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/withdrawal/index.vue